import qs from 'qs';
import { changeBaseNewAPI } from '../../../services';

export const sendNewPassword = async params => {
  const response = await changeBaseNewAPI('post', '/user/password-recovery', qs.stringify(params));
  return response.data;
}